import styled, { css } from 'styled-components';
import { glassMedium } from './glassmorphism';

/**
 * Common form elements with consistent styling
 */

// Base input styles shared by all form controls
const inputBase = css`
  width: 100%;
  padding: 0.75rem;
  ${glassMedium}
  color: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  transition: all 0.3s ease;
  
  &:focus {
    background: rgba(15, 23, 42, 0.6);
    border: 1px solid rgba(99, 102, 241, 0.6);
    box-shadow: 0 0 15px rgba(99, 102, 241, 0.3);
    outline: none;
  }
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
`;

// Text input component
export const Input = styled.input`
  ${inputBase}
`;

// Textarea component
export const Textarea = styled.textarea`
  ${inputBase}
  min-height: 100px;
  resize: vertical;
`;

// Select dropdown component
export const Select = styled.select`
  ${inputBase}
  
  option {
    background: rgba(15, 23, 42, 0.95);
    color: rgba(255, 255, 255, 0.9);
  }
`;

// Form label
export const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  font-size: 0.875rem;
`;

// Form groups (label + input combo)
export const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`;

// Checkbox wrapper for alignment
export const CheckboxGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

// Custom checkbox
export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  width: 18px;
  height: 18px;
  accent-color: rgba(99, 102, 241, 0.8);
  cursor: pointer;
`;

// Radio button wrapper
export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
`;

// Individual radio option
export const RadioOption = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

// Custom radio button
export const Radio = styled.input.attrs({ type: 'radio' })`
  width: 18px;
  height: 18px;
  accent-color: rgba(99, 102, 241, 0.8);
  cursor: pointer;
`;

// Form actions container (for buttons)
export const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
`;

// Form error message
export const ErrorMessage = styled.div`
  color: ${props => props.theme.colors.error || 'rgba(239, 68, 68, 0.9)'};
  font-size: 0.875rem;
  margin-top: 0.5rem;
`;

// Styles for disabled form elements
export const disabledStyles = css`
  opacity: 0.6;
  cursor: not-allowed;
  
  &:hover {
    transform: none;
    box-shadow: none;
  }
`;
